<div *ngFor="let a of authors | keyvalue as author; let inx = index" class="flex items-center truncate mt-1">
  <div [routerLink]="['/a', $any(a.value).username]" class=" text-xs sm: cursor-pointer outline-none {{color}}">
    <span class="text-slate-800 text-xs hover:text-primary duration-300 relative mx-2 font-lg" *ngIf="inx !== 0">-</span>
    {{ $any(a.value).name }}
  </div>
</div>